import { Box, Card, Divider, Stack, Typography } from '@mui/joy';
import { useMemo } from 'react';
import Loader from '../../components/core/Loader';
import Post from '../../components/core/post/Post';
import { NoData } from '../../components/nodata';
import EditorModal from '../../components/postModal';
import useEvent from '../../hooks/useEvent';
import useEventPosts from '../../hooks/useEventPosts';
import { useUser } from '../../hooks/useUser';
import convertJsonToHtml from '../../utils/convertJsonToHtml';

export type EventDetailsMainContentProps = {
  eventId: string;
};

export const EventDetailMainContent = ({
  eventId,
}: EventDetailsMainContentProps) => {
  const userQuery = useUser();
  const postsQuery = useEventPosts(eventId);
  const eventQuery = useEvent(eventId);

  const user = userQuery.data;
  const posts = postsQuery.data;
  const event = eventQuery.data;

  const hasJoined = useMemo(() => {
    if (!postsQuery.isSuccess || !userQuery.isSuccess) return false;
    return event?.attendees?.some((member: any) => {
      return member._id === user?._id;
    });
  }, [event, user, postsQuery.data]);

  if (!postsQuery.isSuccess || !userQuery.isSuccess) {
    return <Loader />;
  }

  return (
    <Stack spacing={2}>
      <Box
        display={{
          xs: 'none',
          md: 'block',
        }}
      >
        <Card variant="outlined">
          <Stack>
            <Typography level="title-lg">{event.title}</Typography>
            <Typography level="body-sm">
              {convertJsonToHtml(event.description)}
            </Typography>
          </Stack>
        </Card>
      </Box>

      <EditorModal
        postId={null}
        setOpen={() => true}
        isOpen={true}
        onPostSubmit={async () => {
          await eventQuery.refetch();
          await postsQuery.refetch();
        }}
      />
      {hasJoined && (
        <>
          <Divider />
          {/* No topics placeholder */}
        </>
      )}
      {!postsQuery.data.length && (
        <div className="w-full flex justify-center pt-[150px]">
          <NoData />
        </div>
      )}

      <Stack gap={2} key={posts.length}>
        {posts.map((post: any) => {
          return (
            <Post
              key={post._id}
              post={post}
              hideQuickNavigate={true}
              refetch={postsQuery.refetch}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
